<template>
  <v-app>
    <div v-if="!logInStatus">
      <router-view></router-view>
    </div>
    <div v-else>
      <app-bar @menuClick="toggleDrawer" />
      <SideNavigation ref="sideNavigation"/>
      <v-main>
        <div class="page-container main-container centered">
          <div @click="redirectOldUI()" class="old-ui-btn" style="float: right">{{ $t('common.beta-ui') }}</div>
          <router-view></router-view>
        </div>
      </v-main>
      <site-notification-viewer />
    </div>
    <corporation-background />
  </v-app>
</template>

<style>
@import './assets/styles/custom.css';
</style>

<script>
import Vue from 'vue';
import VueMeta from 'vue-meta';
import SiteNotificationViewer from './components/chrome/SiteNotificationViewer.vue';
import AppBar from './components/chrome/AppBar.vue';
import CorporationBackground from '@/components/chrome/CorporationBackground';
import SideNavigation from '@/components/navigation/SideNavigation';
import './utils/filters';

Vue.use(VueMeta);

export default Vue.extend({
  name: 'App',
  components: {
    CorporationBackground,
    SiteNotificationViewer,
    AppBar,
    SideNavigation,
  },

  metaInfo() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },

  created() {
    if (this.$store.state.uiStatus.drawerStatus.isOpen === null) {
      const drawerStatus = {
        selectedIndex: 1,
      };
      this.$store.commit('setDrawerStatus', drawerStatus);
    }
  },

  methods: {
    toggleDrawer() {
      this.$refs.sideNavigation.toggleDrawerOpen();
    },
    redirectOldUI() {
      console.log('Redirect old UI');
      window.location.href = `${process.env.VUE_APP_HTTP}${process.env.VUE_APP_API_ADDRESS}`;
    },
    storeRouteAndLogin() {
      const redirectRouteAfterLogin = this.$route.name
          ? {
            name: this.$route.name,
            params: this.$route.params,
          }
          : null;
      this.$store.commit('setRedirectRouteAfterLogin', redirectRouteAfterLogin);
      this.$router.push({ name: 'login' });
    },
  },

  computed: {
    logInStatus() {
      if (this.$route.fullPath === '/') {
        return false;
      }
      return true;
    },
  },

  watch: {
    '$route': function () {
      const token = window.$cookies.get('Authorization');
      if (!token) {
        if (this.$route.name !== 'login') {
          this.storeRouteAndLogin();
        }
      }
    },
  },

  async beforeCreate() {
    const token = window.$cookies.get('Authorization');
    if (!token) {
      if (this.$route.name !== 'login') {
        let path = this.$route.path.split('/');
        if (path[1] === 'requestedUrl') {
          this.$store.commit('setRedirectUrlAfterLogin', decodeURIComponent(path[2]));
        }
        const redirectRouteAfterLogin = this.$route.name
          ? {
              name: this.$route.name,
              params: this.$route.params,
            }
          : null;
        this.$store.commit('setRedirectRouteAfterLogin', redirectRouteAfterLogin);
        this.$router.push({ name: 'login' });
      } else {
        this.$store.commit('setRedirectRouteAfterLogin', null);
      }
    } else {
      try {
        await this.$store.dispatch('user/getUser');
        const user = this.$store.state.user?.user;
        if (user && token) {
          await this.$store.dispatch('userSessionStateStore/update');
          await this.$store.dispatch('corporationSettingsState/update');
        }
      } catch (error) {
        console.log('beforeCreate error', error);
        await this.$store.dispatch('auth/logout');
        this.$router.push({ name: 'login' });
      }
    }
  },
});

Vue.mixin({
  computed: {
    $featurePermissions(){
      return this.$store.getters['userSessionStateStore/featurePermissions'];
    },
  },
});
</script>
<style scoped>
.old-ui-btn {
    background: #21a1e7 none repeat scroll 0 0;
    border-radius: 20px;
    color: white;
    border: 1px solid black;
    cursor: pointer;
    display: inline-block;
    margin-top: 5px;
    margin-right: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 8px;
    padding-right: 8px;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    white-space: nowrap;
}
.old-ui-btn:hover {
  text-decoration: underline;
  }
</style>
